export const AFFILIATE_GROUP_CHANGE_PREVIEW = 'AFFILIATE_GROUP_CHANGE_PREVIEW'
export const CREDIT_SELECT_MANUAL_POPUP_ON_REQUEST = 'CREDIT_SELECT_MANUAL_POPUP_ON_REQUEST'
export const LEAD_DETAILS_SELF_HEAL = 'LEAD_DETAILS_SELF_HEAL'
export const AUTH_NEUTRAL_LOGIN = 'AUTH_NEUTRAL_LOGIN'
export const FLAT_FEE_TYPED_AMOUNT = 'FLAT_FEE_TYPED_AMOUNT'
// WS #2346323: the Program Fee % list starts at 15% (Solar firm only; Modern Financial).
export const PROGRAM_FEE_FLOOR_15 = 'PROGRAM_FEE_FLOOR_15'
export const AFFILIATE_OWNER_MANAGES_TEAM = 'AFFILIATE_OWNER_MANAGES_TEAM'
export const AFFILIATE_STAFF_SCREEN_FIXES = 'AFFILIATE_STAFF_SCREEN_FIXES'
export const ESIGN_DOCS_SIGNER_EVIDENCE = 'ESIGN_DOCS_SIGNER_EVIDENCE'
export const ESIGN_LSA_SIGN_INTENT = 'ESIGN_LSA_SIGN_INTENT'
export const ESIGN_LINK_PAGE_FIT_SCREEN = 'ESIGN_LINK_PAGE_FIT_SCREEN'
export const AFFILIATE_OWNER_SETS_ACCESS = 'AFFILIATE_OWNER_SETS_ACCESS'
export const AFFILIATE_OWNER_RESETS_PASSWORD = 'AFFILIATE_OWNER_RESETS_PASSWORD'
export const AFFILIATE_OWNER_GRANTS_COOWNER = 'AFFILIATE_OWNER_GRANTS_COOWNER'
export const NOTIFICATIONS_BELL = 'NOTIFICATIONS_BELL'
export const PAYMENTS_OFFICE_METHODS = 'PAYMENTS_OFFICE_METHODS'
export const PARTNER_LEAD_SOURCE = 'PARTNER_LEAD_SOURCE'
export const COAPP_CREDIT_REFETCH_TAB = 'COAPP_CREDIT_REFETCH_TAB'
export const CONTACT_ACTIVE_DEDUP_BY_SSN = 'CONTACT_ACTIVE_DEDUP_BY_SSN'
export const PORTAL_CREDIT_SCORES = 'PORTAL_CREDIT_SCORES'
export const CONTACT_FINANCING = 'CONTACT_FINANCING'
// WS #2311820: "Financing pending" on affiliate-billed clients (Modern Financial), the rep's "Lender funded" and a Pending / Funded / Paid list filter.
export const CONTACT_FINANCING_PENDING = 'CONTACT_FINANCING_PENDING'
// WS #2346314: group admins (Kyle's Master login) get Mark paid / Record financing on marked files, up to the pending fee.
export const CONTACT_FINANCING_GROUP_ADMIN = 'CONTACT_FINANCING_GROUP_ADMIN'
// WS #2228909: affiliates (PACK reps) send a PCA; the PCA popup asks for the card and its amount.
export const PCA_FOR_AFFILIATES = 'PCA_FOR_AFFILIATES'
// WS #2219705: PACK reps may enrol a client with no email (clients who only have a phone).
export const CONTACT_EMAIL_OPTIONAL = 'CONTACT_EMAIL_OPTIONAL'
// WS #2228906: the Documents list names each e-signed document (LSA, PCA, card authorization…) instead of a blank Type.
export const ESIGN_DOC_NAMES = 'ESIGN_DOC_NAMES'
// WS #2230103: Create Debts accepts account numbers shorter than 8 characters (on for Solar).
export const CREATE_DEBTS_ACCOUNT_NUMBER_NO_MIN = 'CREATE_DEBTS_ACCOUNT_NUMBER_NO_MIN'
export const DASHBOARD_DRILLDOWN_LINKS = 'DASHBOARD_DRILLDOWN_LINKS'
export const DASHBOARD_CREDIT_PULLS = 'DASHBOARD_CREDIT_PULLS'
export const DOCUMENTS_POA_ADDRESS_NOTICE = 'DOCUMENTS_POA_ADDRESS_NOTICE'
export const NOTES_TAB_FLICKER_GUARD = 'NOTES_TAB_FLICKER_GUARD'
export const MESSAGES_DELIVERY_STATUS = 'MESSAGES_DELIVERY_STATUS'
export const PARKED_CHARGE_VISIBLE = 'PARKED_CHARGE_VISIBLE'
export const PAYMENTS_PERSISTENT_SKIP = 'PAYMENTS_PERSISTENT_SKIP'
// WS #2296193: an office may keep its own Lead Source list (Modern Financial); its leads get a dropdown of only that list.
export const OFFICE_LEAD_SOURCES = 'OFFICE_LEAD_SOURCES'
// WS #2219705: the signing success page offers the just-signed agreement as a download (clients with no email get no emailed copy).
export const LSA_SIGNED_COPY_DOWNLOAD = 'LSA_SIGNED_COPY_DOWNLOAD'
export const LEAD_API_CREATOR_GUARD = 'LEAD_API_CREATOR_GUARD'
// WS #1541341: an opened email shows the address it was sent to, not the contact's enrollment email.
export const EMAILS_SENT_RECIPIENT = 'EMAILS_SENT_RECIPIENT'
export const SIGNING_THANK_YOU_TEXT = 'SIGNING_THANK_YOU_TEXT'
export const WIZARD_DEBT_SUMMARY = 'WIZARD_DEBT_SUMMARY'
export const ESIGN_DOCS_SIGNING_LINK = 'ESIGN_DOCS_SIGNING_LINK'
export const LEADS_DEBT_AMOUNT = 'LEADS_DEBT_AMOUNT'
export const DEBT_AMOUNT_DECIMALS = 'DEBT_AMOUNT_DECIMALS'
export const CONTACT_SOFT_DELETE = 'CONTACT_SOFT_DELETE'
// WS #423817: task form fixes, task reminders, and the Tasks tab for affiliates.
export const TASK_FIXES = 'TASK_FIXES'
export const TASK_REMINDERS = 'TASK_REMINDERS'
export const TASK_REMINDERS_UI = 'TASK_REMINDERS_UI'
export const AFFILIATE_TASKS_UI = 'AFFILIATE_TASKS_UI'
export const LEAD_DISPOSITION_PIPELINE = 'LEAD_DISPOSITION_PIPELINE'
export const FDR_MIN_ONE_PERCENT = 'FDR_MIN_ONE_PERCENT'
export const ACCOUNTING_DAILY_CSV_EMAIL = 'ACCOUNTING_DAILY_CSV_EMAIL'
export const ESIGN_LSA_PAYMENT_UPFRONT = 'ESIGN_LSA_PAYMENT_UPFRONT'
export const CREDIT_STEP_NO_AUTO_REPULL = 'CREDIT_STEP_NO_AUTO_REPULL'
export const CREDIT_PULL_SSN_GUARDS = 'CREDIT_PULL_SSN_GUARDS'
export const DROPDOWN_SEARCH = 'DROPDOWN_SEARCH'
export const PORTAL_DASHBOARD_FIXES = 'PORTAL_DASHBOARD_FIXES'
// WS #2122664: Save on Edit Billing Info waits for the answers and stays open on a refusal (e.g. a bad routing number).
export const EDIT_BILLING_WAIT_FOR_SAVE = 'EDIT_BILLING_WAIT_FOR_SAVE'
// WS #2303654: deleting an agent who still holds files asks who takes them over.
export const AFFILIATE_DELETE_REASSIGN = 'AFFILIATE_DELETE_REASSIGN'
// WS #2515680: internal staff may let an agent add cards for clients of a bank-only office.
export const PAYMENTS_AGENT_CARD_OVERRIDE = 'PAYMENTS_AGENT_CARD_OVERRIDE'
// WS #1944881: the e-sign popup sends a POA or revoked POA for a client billed to the affiliate (no bank or card) with their affiliate method.
export const ESIGN_POPUP_AFFILIATE_BILLING = 'ESIGN_POPUP_AFFILIATE_BILLING'
// WS #2516541: per-user email settings
export const USER_EMAIL_SETTINGS = 'USER_EMAIL_SETTINGS'
// WS #2312369: unsigned e-sign links expire 30 days after they were sent; Resend in the Docs tab also reaches SMS signers.
export const ESIGN_PENDING_LINK_EXPIRY = 'ESIGN_PENDING_LINK_EXPIRY'
// WS #2526336: admin reset offers "Generate password" (shown once) next to "Email reset link".
export const ADMIN_RESET_SHOWS_PASSWORD = 'ADMIN_RESET_SHOWS_PASSWORD'
export const DEBT_WORK_STATUS = 'DEBT_WORK_STATUS'
// WS #2504847: UI kit P2, the shared Button (loading, danger, disabled reason, focus ring) and money Saves that cannot be sent twice.
export const UI_KIT_BUTTON = 'UI_KIT_BUTTON'
// WS #2504847: UI kit P3, ConfirmDialog for money and delete confirms (stays open while it runs, typed check for refund/void and bulk of 10+).
export const UI_KIT_CONFIRM = 'UI_KIT_CONFIRM'
export const AFFILIATE_ASSIGNEE_SPLIT = 'AFFILIATE_ASSIGNEE_SPLIT'
